/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_ErrorInputs */

const en_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fr_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur`)
};

const de_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const it_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore`)
};

const ru_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

const es_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const zh_cn2_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const ja_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const hi_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलती`)
};

const pt_pt2_live_caption_status_error = /** @type {(inputs: Live_Caption_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Live_Caption_Status_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_error = /** @type {((inputs?: Live_Caption_Status_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_status_error(inputs)
	if (locale === "de") return de_live_caption_status_error(inputs)
	if (locale === "it") return it_live_caption_status_error(inputs)
	if (locale === "ru") return ru_live_caption_status_error(inputs)
	if (locale === "es") return es_live_caption_status_error(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_status_error(inputs)
	if (locale === "ja") return ja_live_caption_status_error(inputs)
	if (locale === "hi") return hi_live_caption_status_error(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_status_error(inputs)
	return en_live_caption_status_error(inputs)
});